<bp-icon
	icon="help"
	[style.color]="'#7083A0'"
	customToolTip
	[contentTemplate]="infoTooltip"
	[position]="'top'"
	[additionalOffsetY]="isBlocking ? -70 : -10"></bp-icon>

<ng-template #infoTooltip>
	<div class="ds-tooltip wrapper">
		<div class="main-content">
			<img class="image" [src]="'./assets/Hand (White).svg' | resolveAsset" alt="stop" />
			<div class="content">
				<div>{{ description }}</div>
				<div class="blocking-text" *ngIf="isBlocking">Students are waiting until a spot opens at their destination.</div>
			</div>
		</div>
	</div>
</ng-template>
